import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Stack,
} from "@mui/material";
import Config from "data/config";
import CloseIcon from "@mui/icons-material/Close";
import { createLinkWhatsapp, openLink } from "helpers/ManageLinks";
import { StyledButton } from "./styles";

export interface AppListModalProps {
  modalIsOpen: boolean;
  onClose: () => void;
}

export default function ContactModal({
  modalIsOpen,
  onClose,
}: AppListModalProps): JSX.Element {
  const whatsappLinkSupport = createLinkWhatsapp(
    Config.contact.whatsapp.number,
    ''
  );

    const whatsappLink = createLinkWhatsapp(
    '35920025406',
    ''
  );

  return (
    <Dialog
      open={modalIsOpen}
      onClose={onClose}
      disableScrollLock
      PaperProps={{
        sx: {
          minWidth: "385px",
          backgroundColor: "#ffffff",
          borderRadius: "25px",
          padding: "0rem 1.5rem",
          boxShadow:
            "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
          "@media (max-width: 850px)": {
            minWidth: "unset",
            width: "385px",
            padding: "1rem",
          },
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <DialogTitle>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 8, right: 8, color: "#000000" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      </Box>
      <DialogContent>
        <Box textAlign="center" pb={3} fontSize="18px" fontWeight="700">
          Selecione a opção de contato:
        </Box>
        <Stack spacing={2}>
          <StyledButton onClick={() => openLink(whatsappLinkSupport, "_blank")}>
            Central de atendimento
          </StyledButton>
          <StyledButton
            onClick={() => openLink(whatsappLink, "_blank")}
          >
            Quero contratar
          </StyledButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
